export default __webpack_public_path__ + "static/media/flume-trestle-logo.cd281cc7.svg";